import { makeStyles } from '@material-ui/styles';

const styles = (theme) => ({
    boxStyling: {
        backgroundColor: '#ffffff',
        padding: 24,
        borderRadius: 4,
        boxShadow: theme.customShadows.widget,
    },
});

export default styles;
export const useStyles = makeStyles(styles);
